/**
 * @deprecated
 *
 * This route exposes the JWT in GCP logs, we will get rid of this and move towards
 * CallbackV2.tsx which will do code-exchange via POST request
 */

import { useEffect, useContext } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { AppContext } from '../contexts/AppContext';
import { hasRegistered } from '../lib/jwt';
import Routes from '../lib/routes';

export default function Callback(): JSX.Element {
  const { app, setApp } = useContext(AppContext);
  const history = useHistory();
  const query = new URLSearchParams(useLocation().search);
  const accessToken = query.get('access_token');
  const error = query.get('error');

  useEffect(() => {
    const getDeveloper = async (token: string): Promise<void> => {
      if (hasRegistered(token)) {
        const route = app.nextRedirect;
        // clear nextRedirect so later logins don’t reuse it
        setApp((prevState) => ({
          ...prevState,
          nextRedirect: Routes.Overview,
        }));
        history.push(route || Routes.Overview);
      } else {
        history.push(Routes.Register);
      }
    };
    if (accessToken !== null) {
      const currEnv = app.env;
      const tokens = app.tokens;
      tokens.set(currEnv, accessToken);
      setApp({ ...app, tokens });
      getDeveloper(accessToken);
    } else if (error === 'EMAIL_NOT_VERIFIED') {
      const currEnv = app.env;
      const tokens = app.tokens;
      const t = query.get('token');
      if (t !== null) {
        tokens.set(currEnv, t);
        setApp({ ...app, tokens });
      }
      history.push(`${Routes.Error}/EMAIL_NOT_VERIFIED`);
    }
  });

  return <div className="pageContainer"></div>;
}
